<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'OpenVPNClientList' }">
                <i class="fas fa-chevron-left"></i>
              </router-link>
              Open VPN Client
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Open VPN Client</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="OpenVPNClient">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div v-if="organizationId == 1" class="form-group required">
                    <label class="control-label">Audra</label>
                    <input
                      v-if="is_edit"
                      v-model="pre.audraName[value.accountId]"
                      id="accountId"
                      name="accountId"
                      class="form-control accountId"
                      readonly
                    />
                    <multiselect
                      v-else
                      v-model="value.accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="(opt) => pre.audraName[opt]"
                      placeholder="Select Audra Name"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>
                    
                    <div class="help text-danger" v-show="errors.has('accountId')">
                      {{ errors.first("accountId") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Name</label>
                    <input
                      type="text"
                      id="client_name"
                      name="Client Name"
                      v-model="value.client_name"
                      v-validate="{
                        max: 12,
                        min: 4,
                        required: true,
                        regex: /^[a-zA-Z0-9_]*$/,
                      }"
                      class="form-control client_name"
                      placeholder="Client Name"
                      v-bind:class="{ 'has-error': errors.has('client_name') }"
                    />
                    <div class="help text-danger" v-show="errors.has('Client Name')">
                      {{ errors.first("Client Name") }}
                    </div>
                  </div>
                  <div v-if="vpnType == 0" class="form-group required">
                    <label class="control-label">Password</label>
                    <div class="password">
                    <input
                      id="client_password"
                      name="Client password"
                      v-model="value.password"
                      v-validate="{
                        max: 20,
                        min: 8,
                        required: true,
                        regex: /^[a-zA-Z0-9_]*$/,
                      }"
                      class="form-control client_password"
                      placeholder="Password"
                      v-bind:class="{ 'has-error': errors.has('client_password') }"
                      :type="showPassword ? 'text' : 'password'"
                    />
                    <span class="password-toggle" @click="togglePassword">
                      <i
                        :class="{
                          'icon-eye-off': showPassword,
                          'icon-eye': !showPassword,
                        }"
                      ></i>
                    </span>
                  </div>
                    <div class="help text-danger" v-show="errors.has('Client password')">
                      {{ errors.first("Client password") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Server</label>

                    <multiselect
                      v-model="value.server_id"
                      :options="Object.keys(pre.serverName)"
                      :custom-label="(opt) => pre.serverName[opt]"
                      placeholder="Select Server Name"
                      :searchable="true"
                      :multiple="false"
                      id="server_id"
                      v-bind:class="{ 'has-error': errors.has('server_id') }"
                      v-validate="'required'"
                      name="Server"
                    >
                    </multiselect>
                    
                    <div class="help text-danger" v-show="errors.has('Server')">
                      {{ errors.first("Server") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "OpenVPNClientForm",
  metaInfo: {
    title: "Open VPN Client | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),

    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    vpnType: 1,
showPassword:false,
    value: {},
    pre: {
      audraName: [],
      serverName: [],
    },
  }),
  methods: {
     togglePassword() {
      this.showPassword = !this.showPassword;
    },
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/open_vpn_clients";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/open_vpn_clients/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "OpenVPNClientList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/open_vpn_clients/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back();
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
      }

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });
      this.is_loading = false;
    },

    getServerName: function () {
      axios
        .get("get-server-name", {
          params: { accountId: LocalStorage.get("accountId") },
        })
        .then((response) => {
          this.pre.serverName = response.data;
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {});
    },

    getOpenVpnType: function () {
      axios
        .get("get-openvpn-type", {
          params: { accountId: LocalStorage.get("accountId") },
        })
        .then((response) => {
          this.vpnType = response.data;
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.getServerName();
    this.getOpenVpnType();
    this.initialize();
  },
};
</script>
